<template>
  <div class="rounded-lg shadow bg-white p-4">
    <div class="flex justify-between items-center mb-4">
      <h2 class="font-bold text-xl">스태프 관리</h2>
      <Button :type="ButtonTypes.blue" label="스태프 생성" :onClick="openCreate" />
    </div>

    <b-table :items="staffs" :fields="fields" responsive>
      <template #cell(role)="data">{{ roleLabel(data.item.role) }}</template>
      <template #cell(actions)="data">
        <button class="btn btn-sm btn-outline-secondary mr-2" @click="openEdit(data.item)">정보/권한 변경</button>
        <button class="btn btn-sm btn-outline-primary mr-2" @click="openPassword(data.item)">비밀번호 변경</button>
        <button class="btn btn-sm btn-outline-danger" @click="remove(data.item)">삭제</button>
      </template>
    </b-table>

    <b-modal v-model="createOpen" :title="editingId ? '스태프 정보/권한 변경' : '스태프 생성'" hide-footer>
      <b-form-group label="이름"><b-form-input v-model="form.name" /></b-form-group>
      <b-form-group label="이메일"><b-form-input v-model="form.email" type="email" :disabled="!!editingId" /></b-form-group>
      <b-form-group v-if="!editingId" label="비밀번호"><b-form-input v-model="form.password" type="password" /></b-form-group>
      <b-form-group label="역할">
        <b-form-select v-model="form.role" :options="roleOptions" />
      </b-form-group>
      <b-form-group label="노출 메뉴">
        <div v-for="menu in availableMenus" :key="menu.id" class="mb-2">
          <b-form-checkbox v-model="form.menuIds" :value="menu.id">{{ menu.name }}</b-form-checkbox>
          <div v-for="child in menu.children" :key="child.id" class="ml-4">
            <b-form-checkbox v-model="form.menuIds" :value="child.id">{{ child.name }}</b-form-checkbox>
          </div>
        </div>
      </b-form-group>
      <div class="text-right"><button class="btn btn-primary" @click="save">{{ editingId ? '변경' : '생성' }}</button></div>
    </b-modal>

    <b-modal v-model="passwordOpen" title="비밀번호 변경" hide-footer>
      <b-form-input v-model="newPassword" type="password" placeholder="새 비밀번호" />
      <div class="text-right mt-3"><button class="btn btn-primary" @click="changePassword">변경</button></div>
    </b-modal>
  </div>
</template>

<script>
import api from '@/api/api'
import Button from '@/components/Button.vue'
import {ButtonTypes} from '@/util/enums'

export default {
  components: {Button},
  computed: {
    ButtonTypes() { return ButtonTypes },
    availableMenus() {
      if (this.form.role !== 'ROLE_CALL_ADMIN') return this.menus
      return this.menus.filter((menu) => !this.kakaoManagementRouteNames.includes(menu.routeName))
    },
    kakaoManagementRouteNames() { return ['KakaoManagement', 'PtTeacherKakaoManagement'] },
  },
  watch: {
    'form.role'(role) {
      if (role !== 'ROLE_CALL_ADMIN') return
      const kakaoMenuIds = this.menus
        .filter((menu) => this.kakaoManagementRouteNames.includes(menu.routeName))
        .map((menu) => menu.id)
      this.form.menuIds = this.form.menuIds.filter((id) => !kakaoMenuIds.includes(id))
    },
  },
  data() {
    return {
      staffs: [], menus: [], createOpen: false, passwordOpen: false,
      selected: null, newPassword: '', editingId: null,
      form: {name: '', email: '', password: '', role: 'ROLE_READ_ADMIN', menuIds: []},
      fields: [
        {key: 'name', label: '이름'}, {key: 'email', label: '이메일'},
        {key: 'role', label: '역할'}, {key: 'actions', label: ''},
      ],
      roleOptions: [
        {value: 'ROLE_ADMIN', text: '관리자'},
        {value: 'ROLE_READ_ADMIN', text: '조회 관리자'},
        {value: 'ROLE_CALL_ADMIN', text: '콜 관리자'},
      ],
    }
  },
  mounted() { this.load() },
  methods: {
    load() {
      Promise.all([api.staff.list(), api.staff.menus()]).then(([staffs, menus]) => {
        this.staffs = staffs.data
        this.menus = menus.data
      })
    },
    openCreate() {
      this.editingId = null
      this.form = {name: '', email: '', password: '', role: 'ROLE_READ_ADMIN', menuIds: []}
      this.createOpen = true
    },
    openEdit(staff) {
      this.editingId = staff.id
      this.form = {name: staff.name, email: staff.email, password: '', role: staff.role, menuIds: [...staff.menuIds]}
      this.createOpen = true
    },
    save() {
      const request = this.editingId
        ? api.staff.update(this.editingId, this.form)
        : api.staff.create(this.form)
      request.then(() => { this.createOpen = false; this.load() })
    },
    openPassword(staff) { this.selected = staff; this.newPassword = ''; this.passwordOpen = true },
    changePassword() {
      api.staff.changePassword(this.selected.id, this.newPassword).then(() => { this.passwordOpen = false })
    },
    remove(staff) {
      if (!confirm(`${staff.name} 스태프를 삭제하시겠습니까?`)) return
      api.staff.delete(staff.id).then(() => this.load())
    },
    roleLabel(role) {
      return {ROLE_ADMIN: '관리자', ROLE_READ_ADMIN: '조회 관리자', ROLE_CALL_ADMIN: '콜 관리자'}[role] || role
    },
  },
}
</script>
